import React from 'react'

export const CrossVector = () => (
  <svg
    className="MIRECO-cross"
    width="24"
    height="24"
    viewBox="0 0 6.35 6.35"
  >
    <g
      transform="translate(0,-290.65)"
    >
      <path
        style={{
          fill: 'none',
          stroke: '#333333',
          strokeWidth: '0.66145833',
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: '4',
          strokeDasharray: 'none',
          strokeOpacity: '1',
        }}
        d="m 1.0583333,291.70833 4.2333334,4.23334"
      />
      <path
        style={{
          fill: 'none',
          stroke: '#333333',
          strokeWidth: '0.66145833',
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: '4',
          strokeDasharray: 'none',
          strokeOpacity: '1',
        }}
        d="m 1.0583333,295.94167 4.2333334,-4.23334"
      />
    </g>
  </svg>
)
